<template>
  <v-container fluid>
    <RenewForm
      :programme="currentRegistration ? currentRegistration.programme : ''"
      :programmeStages="programmeStages"
      :semesters="semesters"
      :setupProgrammes="setupProgrammes"
      :currentRegistration="currentRegistration"
    />
    <v-card>
      <v-card-title> Register units </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6" lg="6">
            <v-card flat>
              <div class="overline mt-1">Available Units</div>
              <v-divider />
              <v-data-table
                dense
                :headers="headers"
                :items="currentStage ? currentStage.programmeUnits : []"
                hide-default-footer
                disable-pagination
              >
                <!--eslint-disable-next-line -->
              <template v-slot:item.description="{ item }">
                  <div>
                    {{ `${item.description}` }}
                    <v-chip
                      class="my-1 white--text"
                      label
                      small
                      :color="
                        item.mandatoryUnit
                          ? 'deep-orange lighten-1'
                          : 'teal lighten-1'
                      "
                    >
                      {{ item.code }}
                      <v-divider vertical class="mx-2" />
                      {{ item.mandatoryUnit ? "mandatory" : "optional" }}
                    </v-chip>
                  </div>
                </template>
                <!--eslint-disable-next-line -->
              <!--eslint-disable-next-line -->
              <template v-slot:item.unitFees="{ item }">
                  {{ item.unitFees | currency }}
                </template>
                <!--eslint-disable-next-line -->
              <template v-slot:item.exemptionFees="{ item }">
                  {{ item.exemptionFees | currency }}
                </template>
                <!--eslint-disable-next-line -->
              <template v-slot:item.exempt="{ item }">
                  <v-checkbox
                    v-model="registrationForm.unitsExempted"
                    :value="item"
                    color="accent"
                    :disabled="
                      item.mandatoryUnit ||
                      registrationForm.unitsTaken.find(
                        (u) => u.code === item.code,
                      )
                    "
                  ></v-checkbox>
                </template>
                <!--eslint-disable-next-line -->
              <template v-slot:item.register="{ item }">
                  <v-checkbox
                    v-model="registrationForm.unitsTaken"
                    :value="item"
                    color="primary"
                    :disabled="
                      registrationForm.unitsExempted.find(
                        (u) => u.code === item.code,
                      ) || item.mandatoryUnit
                    "
                  ></v-checkbox>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="12" md="3" lg="3">
            <v-card flat>
              <div class="overline mt-1">Other Charges</div>
              <v-divider />
              <v-data-table
                :headers="chargesHeaders"
                :items="currentStage ? currentStage.stageCharges : []"
                hide-default-footer
              >
                <!--eslint-disable-next-line -->
              <template v-slot:item.description="{ item }">
                  {{ item.description }}
                </template>
                <!--eslint-disable-next-line -->
              <template v-slot:item.amountEarly="{ item }">
                  {{ item.amountEarly | currency }}
                </template>
                <!--eslint-disable-next-line -->
              <template v-slot:item.add="{ item }">
                  <v-checkbox
                    v-model="registrationForm.otherCharges"
                    :value="item"
                    color="primary"
                  ></v-checkbox>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="12" md="3" lg="3">
            <v-card tile flat>
              <div class="overline mt-1">Billing Summary</div>
              <v-divider />
              <v-simple-table class="mt-3" dense>
                <thead class="caption text-center">
                  <tr>
                    <th class="text-left">Item</th>
                    <th class="text-center">Qty</th>
                    <th class="text-right">Amount</th>
                  </tr>
                </thead>
                <tbody class="caption">
                  <tr>
                    <td class="text-left caption">Units</td>
                    <td class="text-center caption">
                      {{ registrationForm.unitsTaken.length }}
                    </td>
                    <td class="text-right caption">
                      {{ totals.taken | currency }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left caption">Exemptions</td>
                    <td class="text-center caption">
                      {{ registrationForm.unitsExempted.length }}
                    </td>
                    <td class="text-right caption">
                      {{ totals.exempted | currency }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left caption">Other Charges</td>
                    <td class="text-center caption">
                      {{ registrationForm.otherCharges.length }}
                    </td>
                    <td class="text-right caption">
                      {{ totals.charges | currency }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>

              <v-divider class="mt-5" />

              <v-simple-table dense class="overline pa-2">
                <tr class="text-right">
                  <td>Total</td>
                  <td>
                    {{
                      (totals.charges + totals.taken + totals.exempted)
                        | currency
                    }}
                  </td>
                </tr>
              </v-simple-table>

              <v-divider />

              <v-card-actions>
                <v-spacer />
                <!-- <v-btn
                  :disabled="
                    totals.charges + totals.taken + totals.exempted === 0
                  "
                  small
                  tile
                  color="blue"
                  class="white--text"
                  @click="saveRegistration"
                >
                  <v-icon left>mdi-content-save</v-icon>
                  save</v-btn
                > -->

                <v-btn
                  :disabled="
                    totals.charges + totals.taken + totals.exempted === 0
                  "
                  small
                  tile
                  color="success"
                  @click="saveRegistration"
                >
                  <v-icon left>mdi-arrow-right</v-icon>
                  Proceed</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
// import { helper } from "../../dashboard/utils";
import AuthService from "../../dashboard/modules/auth/AuthService";
import RenewForm from "../components/renewForm.vue";
export default {
  name: "registrationCards",
  components: { RenewForm },
  data: function () {
    return {
      dialog: false,
      headers: [
        { text: "Unit", value: "description", align: "start", sortable: false },
        { text: "Unit Fee", value: "unitFees", sortable: false },
        { text: "Exemption Fee", value: "exemptionFees", sortable: false },
        { text: "Exempt", value: "exempt", sortable: true },
        { text: "Register", value: "register", sortable: true },
      ],
      chargesHeaders: [
        { text: "item", value: "description", sortable: false },
        { text: "Amount", value: "amountRegular", sortable: true },
        { text: "", value: "add", sortable: true },
      ],
      registrationForm: {
        unitsTaken: [],
        unitsExempted: [],
        otherCharges: [],
      },
    };
  },
  mounted() {
    Event.$on("proceed-payment", () => {
      this.checkout();
    });
  },
  computed: {
    setupProgrammes() {
      return this.$store.getters["Renewal/setupProgrammes"];
    },
    studentRegistrations() {
      let currPro = this.$store.getters["Renewal/currentProgramme"];
      return currPro.length !== 0 ? currPro : [];
    },
    programmeStages() {
      return this.$store.getters["Renewal/programmeStages"];
    },
    semesters() {
      return this.$store.getters["Renewal/semesters"];
    },
    currentRegistration() {
      return this.studentRegistrations.filter(
        (item) => item.programme === this.$route.query.programme,
      )[0];
    },
    currentStage() {
      if (!this.currentRegistration) return [];
      const program = this.setupProgrammes
        .filter((p) => p.code === this.currentRegistration.programme)
        .shift();
      if (program) {
        const returnValue = program.programmeStages
          .filter((s) => s.code === this.currentRegistration.intakeStage)
          .shift();
        this.checkMandatory(returnValue);
        return returnValue;
      } else {
        return null;
      }
    },
    totals() {
      let total = {
        taken: 0,
        exempted: 0,
        charges: 0,
      };
      this.registrationForm.unitsTaken.forEach((u) => {
        total.taken += u.unitFees;
      });
      this.registrationForm.unitsExempted.forEach((u) => {
        total.exempted += u.unitFees;
      });
      this.registrationForm.otherCharges.forEach((u) => {
        total.charges += u.amountRegular;
      });

      return total;
    },
  },
  methods: {
    saveRegistration: function () {
      const { unitsTaken, unitsExempted, otherCharges } = this.registrationForm;
      const reg = this.currentRegistration;
      this.$confirm.show({
        title: "Register Units?",
        text: `Are you sure you want to register the selected units?`,
        onConfirm: () => {
          this.$store.dispatch("Renewal/submitRegistrationUnits", {
            charges: {
              otherCharges: otherCharges.map((item) => {
                return {
                  studentNo: AuthService.user.profile.studentNo,
                  profileID: AuthService.user.profile.profileID,
                  amount: item.amountRegular,
                  chargeType: "Registration",
                  intake: reg.intakeStage,
                };
              }),
            },
            units: {
              unitsTaken: unitsTaken.map((item) => {
                return {
                  programme: item.programmeCode,
                  studentNo: AuthService.user.profile.studentNo,
                  profileID: AuthService.user.profile.profileID,
                  stage: reg.intakeStage,
                  intakeYear: reg.intakeStage,
                  semester: reg.intakeSemester,
                  unit: item.code,
                  taken: true,
                  paper: item.description,
                };
              }),
              unitsExempted: unitsExempted.map((item) => {
                return {
                  programme: item.programmeCode,
                  studentNo: AuthService.user.profile.studentNo,
                  profileID: AuthService.user.profile.profileID,
                  stage: reg.intakeStage,
                  intakeYear: reg.intakeStage,
                  semester: reg.intakeSemester,
                  unit: item.code,
                  exempted: true,
                  paper: item.description,
                };
              }),
            },
          });
        },
      });
    },
    checkout() {
      this.$billing.proforma({
        payerID: this.currentRegistration.studentNo, // ProfileID, StudentID
        sourceDocumentNo: this.currentRegistration.registrationID, // Payment Doc No.
        description: "Exam Fees", // Payment Description < 10 Chars
        amount: this.currentRegistration.billedAmount, // Payment amount Int
        success_url: window.location.href, // on successful payment
        fail_url: window.location.href, // on failed payment
        onConfirm: () => {
          Event.$emit("ApiInfo", "Payment Confirmed");
        }, // On confirm Pay callback
        onCancel: () => {
          Event.$emit("ApiInfo", "Payment Cancelled");
        }, // on Cancel Pay Callback
      });
    },
    checkMandatory(program) {
      const mandatoryUnits = [];
      program.programmeUnits.map((item) => {
        if (item.mandatoryUnit) mandatoryUnits.push(item);
      });
      this.registrationForm.unitsTaken = mandatoryUnits;
    },
  },
};
</script>
